module.exports = __webpack_public_path__ + "static/media/desktopScreenshot06.cf6acb6e.jpg";